import Api from '@/api/index'

const state = {
  all: [],
}

const actions = {
  async create(ctx, payload) {
    return Api.Shipment.create(payload)
  },

  async getAll({ commit }, params) {
    const result = await Api.Shipment.getAll(params)
    if (result && result.data) {
      const items = Array.isArray(result.data)
        ? result.data
        : result.data.items || result.data.data || []
      commit('setShipments', items)
    }
    return result
  },

  async getById(ctx, id) {
    return Api.Shipment.getById(id)
  },

  async update(ctx, { id, payload }) {
    return Api.Shipment.update(id, payload)
  },

  async assignMessenger(ctx, { id, assignedUserId, comment }) {
    return Api.Shipment.assignMessenger(id, assignedUserId, comment)
  },

  async changeStatus(ctx, { id, status, comment }) {
    return Api.Shipment.changeStatus(id, status, comment)
  },

  async startTrip(ctx, { id, payload }) {
    return Api.Shipment.startTrip(id, payload)
  },

  async getBitacora(ctx, id) {
    return Api.Shipment.getBitacora(id)
  },

  async getTracking(ctx, id) {
    return Api.Shipment.getTracking(id)
  },
}

const mutations = {
  setShipments(state, items) {
    state.all = items
  },
}

const getters = {}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
